const TENANT_GUID_SANTILLANA_DEMO = '71bfaecf-c8d8-40dd-b297-35bca1acce82';
const SANTILLANA_INTEGRATIONS = '9d9f77ae-6747-42a5-a5f1-1c67e2a5a878';

export function isSantillanaDemo(tenantGuid) {
  return [TENANT_GUID_SANTILLANA_DEMO].includes(tenantGuid);
}

export function isTangerine(tenantGuid) {
  return tenantGuid === 'TANGERINE';
}

export function isSantillanaIntegrations(tenantGuid) {
  return tenantGuid === SANTILLANA_INTEGRATIONS;
}

export function isUnoIntMx(organization) {
  if (organization) {
    const { tenant } = organization;
    const validTenants = ['UnoInt-MX'];
    return validTenants.includes(tenant.name);
  }

  return false;
}
